import { useState, useEffect, useRef } from "react";
import { getServicios, getServicioProceso } from "../../services/servicios";
import { socketon } from "../../utils/socket";
import { ErrorContext } from "../../utils/context/error";
//import { BreadContext } from "../../utils/context/breadcrum";
import CardTurno from "./card";
import Icon from "../../Icons/general/Icon";
import LlamarModal from "./llamarmodal";

function TurnView() 
{
   const [Servicios, setServicios] = useState([]);
   const [Modulo, setModulo] = useState([]);
   const [Datos, setDatos] = useState([]);
   const {setShowToast, setOpciones } = ErrorContext();
   //const { setRuta} = BreadContext();
   const [footerv, setFooter] = useState(false);
   const [disabled, setDisabled] = useState(false);
   const [showM, setShowM] = useState(false);
   const ServicioId  = useRef(0);
   const Area  = useRef(0);
  
   const fillSelectServicios = async () =>
    {
       const response = await getServicios();
       if (response)
        {
           if (response.status === 200) 
            {
               setServicios(response.data.data);
               setModulo(response.data.modulo[0]);
               setDatos(response.data.Turnos);
            } 
            else 
            {
               const Mensaje = response.message;
               const opc = { type: "Danger", message: Mensaje, active: true };
               setOpciones(opc);
               setShowToast(true);
            }
        }
    };
  const VerificarEstadoModulo = async(TurnoId, ModuloId, cards) =>
    {
       let Estado =false;
       const response = await getServicioProceso(TurnoId, ModuloId);
       if (response) 
        {
          if (response.status === 200) 
            {
              if (response.data.data.length >0)
                setDisabled(false)
              else
                setDisabled(true)
            } 
          else 
           {
             const Mensaje = response.message;
             const opc = { type: "Danger", message: Mensaje, active: true };
             setOpciones(opc);
             setShowToast(true);
           }
      }
  }
  /**
   * recibe los datos desde el socket
   */
  const actualizaDatosSk = () => 
    {
       socketon.on("ActualizaPendientes", (message, sender) => 
        {
         if (message)
          {
            setDatos((prevDatos) => {
                  const nuevosIds = message.map((d) => d.ServicioId);
                  const datosFiltrados = prevDatos.filter((d) => !nuevosIds.includes(d.ServicioId));
                  return [...datosFiltrados, ...message];
              });
          }
        });
    };
  /**
   * al dar la opcion de atender
   */

  useEffect(() => 
    {
      actualizaDatosSk();
      fillSelectServicios();
      //setRuta("Digiturno / Atender Turno");
      return () => 
        {
           socketon.on("disconnect", () => {    });
         };
    },[]);

  const togglePanel=()=> 
  {
     if (footerv)
        setFooter(false)
     else
        setFooter(true)
  }

  const handleTurno = async (item) =>
  {
    Area.current = item.AreaId;
    ServicioId.current = item.ServicioId;
    setShowM(true);
    setDisabled(true);
  }

  return (
    <>
      <div className="flex flex-col w-full h-min">
         <div className="flex flex-row w-full border-b border-stone-200 justify-between pb-1">
            <div className="text-left text-[1.09rem] font-medium text-gray-500">LLamar Turnos</div>
            <div className="text-right text-[1.09rem] font-medium text-gray-500">
               <span>Modulo  </span> 
                <span>{Modulo?.CodigoMod}</span>
            </div>
          </div>

        <div className="h-full w-full grid grid-cols-1 lg:grid-cols-2 gap-4 flex-1 mt-9 px-4 overflow-auto items-start scroll-hidden touch-manipulation">
          {Servicios.map((item) => {
            const turno = Datos.find((d) => d.ServicioId === item.ServicioId);
            return(
                 <div key={item.ServicioId}>
                   <CardTurno data={turno} servicio={item} disabled={false} onClick={handleTurno}></CardTurno>
                 </div>
               );
          })}
        </div>
      </div>
        {footerv && ( 
          <div className="h-[6rem] w-full fixed bottom-0 text-center justify-center items-center touch-manipulation bg-light border-t border-stone-200">
              <ul className="flex flex-row h-full w-full space-y-1 text-center justify-center items-center mt-6">
                  {Servicios.map((item) => 
                  {
                     return (
                            <li key={item.ServicioId} className="w-full h-full text-center justify-center items-center">
                              <span className="text-gray-500 text-center justify-center items-center">{item.Prefijo} </span> - {item.NombreServ}
                            </li>
                         );
                  })}
              </ul>
          </div>)}

      <div id="toggle-button"
                  onClick={togglePanel}
                  className="fixed w-9 h-9 bottom-6 right-6 rounded-full  flex justify-center items-center hover:border-default 
                             transition-transform  hover:scale-110 hover:cursor-pointer">
                    <Icon svg="chevronup" className={`w-7 h-7 fill-default opacity-80 hover:opacity-100 ${footerv ? 'rotate-180':'rotate-0'}`} title="errorCircle" />   
          </div>
{showM ?          
        (<LlamarModal
             show={showM}
             areaId={Area.current}
             servicioId={ServicioId.current}
             handleshow={setShowM}
        ></LlamarModal>) :""}

    </>
  );
}


export default TurnView;
